import { Editable } from 'libs/end-to-end/src/types/generic/generic';
import { z } from 'zod';

export const RubricGradingTypes = ['resume', 'interview', 'questions'] as const;

export const RubricGradingType = z.enum(RubricGradingTypes);

export type RubricGradingType = z.infer<typeof RubricGradingType>;

export const RubricStatuses = ['draft', 'archived', 'published'] as const;

export const RubricStatus = z.enum(RubricStatuses);

export type RubricStatus = z.infer<typeof RubricStatus>;

export const RubricRoleOperations = ['isEqualTo', 'contains'] as const;

export const RubricRoleOperation = z.enum(RubricRoleOperations);

export type RubricRoleOperation = z.infer<typeof RubricRoleOperation>;

export type RubricRole = {
  roleOperation: RubricRoleOperation;
  name: string;
};

export type EditableRubricRole = Editable<RubricRole>;

export type EditableRubricRoleWithError = EditableRubricRole & {
  requiredRoleError: boolean;
  duplicateRoleError: boolean;
};

export type RubricCategory = {
  label: string;
  criteria: {
    text: string;
    weight: number;
  }[];
  tags: string[];
};

export type EditableRubricCategory = Editable<RubricCategory> & {
  id?: string;
};

export type EditableRubricCategoryWithError = EditableRubricCategory & {
  duplicateLabelError: boolean;
  duplicateLabelServerError: boolean;
  requiredLabelError: boolean;
  requiredCriteriaErrors: number[]; // list of indexes of criteria that are missing
};
